
export enum AnimationState {
  STARTED,
  IDLE,
  DRAWING,
  FINISHING,
  ERROR,
}

export enum GameStatus {
  ACTIVE,
  IDLE,
}


export enum GAME_RISK {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum GAME_TYPE {
  MANUAL = 'manual',
  AUTO = 'auto',
}

export interface IFormInput {
  amount: string
  mode: GAME_RISK
  denom: string
}
